import React from 'react'
import { Navigate } from 'react-router-dom'
import tw from 'twin.macro'
import { useUser } from '../../contexts/UserContext'
import { PageLayoutCol } from '../../styles/Layout'
import { Login } from '../Auth/Login'

const ResetPasswordPage = () => {
  const { user } = useUser()

  return user ? (
    <Navigate to="/" />
  ) : (
    <Page>
      <Login />
    </Page>
  )
}

export default ResetPasswordPage

const Page = tw(PageLayoutCol)`items-center `
